export default "__VITE_ASSET__DHc84jr$__"